import {gsap} from "gsap";

export class SpineGSAPWrapper {

    //originally stolen from dead canary, now dumbed down a lot, seems like it still gets the job done
    //loopCount = 0: *  duration of tween is equal to one play though
    //loopCount > 0: *   duration + duration * loopCount
    //loopCount = -1: Loop for ever,

    public static createTimeline(target:PIXI.spine.Spine, trackIndex:number, animationName:string = "", loopCount:number = 0, animationAlpha:number = 1, mixDuration:number = 0):gsap.core.Timeline {
        target.autoUpdate = true;
        const animation:PIXI.spine.core.Animation = target.spineData.findAnimation(animationName);
        const spineShouldLoop:boolean = loopCount != 0;
        const duration = Math.max(mixDuration, !!animation
                                               ? Math.max(animation.duration,
                                                          animation.duration + (animation.duration * loopCount))
                                               : 0);

        return gsap.timeline()
            .add(() => SpineGSAPWrapper.setAnimation(target, trackIndex, animation, spineShouldLoop, animationAlpha, mixDuration))
            .add(gsap.to(this, {duration:duration}),-0.0001)
            .add(() => {
                if (loopCount > 0) {
                    SpineGSAPWrapper.stopLoop(target, trackIndex, animation);
                }
            })
    }

    private static stopLoop(target:PIXI.spine.Spine, trackIndex:number, animation:PIXI.spine.core.Animation) {
        const trackEntry:PIXI.spine.core.TrackEntry = target.state.getCurrent(trackIndex);
        if (trackEntry.animation == animation) {
            trackEntry.loop = false;
        }
    }

    private static setAnimation(target:PIXI.spine.Spine, trackIndex:number, animation:PIXI.spine.core.Animation, loop:boolean, animationAlpha:number, mixDuration:number) {
        const trackEntry:PIXI.spine.core.TrackEntry = target.state.setAnimationWith(trackIndex, animation, loop);
        trackEntry.alpha = animationAlpha;
        trackEntry.mixDuration = mixDuration;
    }
}